import Layout from "components/Layout";
import CustomRouter from "./Router";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useEffect, useMemo } from "react";
import {
  getUserColorThemeMode,
  getUserLanguage,
  setUserColorThemeMode,
} from "utils/local-storage";
import { useDispatch } from "react-redux";
import { markUI } from "stores/ui/uiSlice";
import { useAppSelector } from "hooks/store/hooks";
import { selectpaypalClientId } from "stores/auth/authSlice";

function App() {
  // Initialize Redux dispatch function
  // Select values from the Redux store
  const clientId = useAppSelector(selectpaypalClientId)

  const dispatch = useDispatch();

  useEffect(() => {
    // Retrieve stored user preferences or fallback to defaults
    const colorThemeMode = getUserColorThemeMode() || "light";
    const languageMode = getUserLanguage() || "pl";

    // Update UI state with the retrieved preferences
    void dispatch(markUI({ colorThemeMode, language: languageMode }));

    // Store default theme in local storage if it’s not already set
    if (!getUserColorThemeMode()) {
      setUserColorThemeMode("light");
    }

    // Note: we deliberately don't clear crashCounter/lastCrashTime here.
    // FallbackUI resets the counter on its own when the next crash falls
    // outside CRASH_LOOP_WINDOW_MS; clearing here would race with that
    // window and prevent the loop guard from ever counting to 3.
  }, [dispatch]); // Runs once when the component mounts
  // PayPal configuration options
  const initialOptions = useMemo(
    () => ({
      "client-id": clientId,
      currency: "USD",
      intent: "capture",
    }),
    [clientId]
  );
  return (
    <Layout>
      {/* Renders the application's routes inside the main layout */}
      <PayPalScriptProvider options={initialOptions}>
        <CustomRouter />
      </PayPalScriptProvider>
    </Layout>
  );
}

export default App;
